"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleExclusiveRegistrationNumberValidation = void 0;
const FalconValidationMethodBase_1 = require("./FalconValidationMethodBase");
/**
 * Validates exclusive cases (Q registration numbers and diplomat numbers) of vehicle registration numbers
 */
class VehicleExclusiveRegistrationNumberValidation extends FalconValidationMethodBase_1.FalconValidationMethodBase {
    constructor(props, commandsExecutor) {
        super(commandsExecutor);
    }
    validateInput(input, context) {
        if (context && context.interaction && context.interaction.vehicles && input) {
            if (input.match("(^Q[a-zA-Z0-9]{6,}$)|(^[0-9]{3,}[X|D][0-9]{3,}$)")) {
                return this.invalidResult(this.getErrorMessage(context, "Sorry we are unable to insure this vehicle"));
            }
        }
        return this.validResult();
    }
}
exports.VehicleExclusiveRegistrationNumberValidation = VehicleExclusiveRegistrationNumberValidation;
//# sourceMappingURL=VehicleExclusiveRegistrationNumberValidation.js.map